export function buildingDrawRect({
  sourceWidth,
  sourceHeight,
  tileX,
  tileY,
  tileSize,
}: {
  sourceWidth: number;
  sourceHeight: number;
  tileX: number;
  tileY: number;
  tileSize: number;
}): { x: number; y: number; width: number; height: number } {
  const width = sourceWidth > 0 ? sourceWidth : tileSize;
  const height = sourceHeight > 0 ? sourceHeight : tileSize;
  return {
    x: tileX * tileSize + (tileSize - width) / 2,
    y: tileY * tileSize + (tileSize - height) / 2,
    width,
    height,
  };
}

export function drawBuildingImage({
  ctx,
  img,
  tileX,
  tileY,
  tileSize,
}: {
  ctx: CanvasRenderingContext2D;
  img: HTMLImageElement;
  tileX: number;
  tileY: number;
  tileSize: number;
}): void {
  const rect = buildingDrawRect({
    sourceWidth: img.naturalWidth,
    sourceHeight: img.naturalHeight,
    tileX,
    tileY,
    tileSize,
  });
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(img, rect.x, rect.y, rect.width, rect.height);
}
